import {
  AppBar as MuiAppBar,
  Button,
  Divider,
  Stack,
  styled as muiStyled,
} from '@mui/material';
import type { AppBarProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const AppBar = muiStyled(MuiAppBar)<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  background: NEW_COLORS.BASE.WHITE,
  padding: '16px 0',
  boxShadow: 'none',
}));

const MenuButton = muiStyled(Button)(() => ({
  color: NEW_COLORS.GRAYSCALE[700],
  fontWeight: 400,
  fontSize: 14,
  '& .MuiButton-startIcon': {
    color: NEW_COLORS.SECONDARY[500],
  },
}));

const PageTitleContainer = muiStyled(Stack)(() => ({
  svg: {
    color: NEW_COLORS.SECONDARY[500],
    fontSize: 32,
  },

  '.icon-chevron-right': {
    color: NEW_COLORS.GRAYSCALE[700],
  },

  height: '100%',
  alignItems: 'center',
}));

const MobileDivider = muiStyled(Divider)(({ theme }) => ({
  width: 'calc(100% + 32px)',
  margin: '20px 0 16px -16px',
  backgroundColor: NEW_COLORS.GRAYSCALE[200],
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export { MobileDivider, PageTitleContainer, MenuButton, AppBar };
